module.exports = __webpack_public_path__ + "static/media/tmdb_logo.30bc6b19.svg";